import { createSlice } from "../helper";

const commonDetailsInitialState = {
  data: {
    customTerms: null,
    isMobile: null,
    isWorkingOnBehalf: null,
    wobMember: {},
    meetingSetGuidesConfig: {
      applicableForProgram: null,
      applicableForGroupUrl: null,
      guideSelectionPath: null
    },
    standaloneGuidesConfig: {
      applicableForProgram: null
    },
    groupId: null,
    currentConnectionMembershipRoleName: null
  }
}

const commonDetailsSlice = createSlice({
  name: 'Common Details',
  initialState: commonDetailsInitialState,
  reducers: {
    setCommonData: (state, action) => {
      const data = {
        customTerms: action.payload.customTerms,
        isMobile: action.payload.isMobile,
        isMobileApp: action.payload.isMobileApp,
        isMobileOrTablet: action.payload.isMobileOrTablet,
        isWorkingOnBehalf: action.payload.isWorkingOnBehalf,
        wobMember: action.payload.wobMember,
        meetingSetGuidesConfig: action.payload.meetingSetGuidesConfig || {},
        standaloneGuidesConfig: action.payload.standaloneGuidesConfig || {},
        groupId: action.payload.groupId,
        currentConnectionMembershipRoleName: action.payload.currentConnectionMembershipRoleName,
        connectionIdHash: action.payload.connectionIdHash
      }
      state.data = data;
    }
  }
});

export const commonDetailsActions = commonDetailsSlice.actions;

export default commonDetailsSlice;
